import React, { Component, Fragment } from "react";
import "./sizing.css";
import { Link } from "react-router-dom";

export default class DryerGasPurgeSizing extends Component {

    render() {
        return (
            <Fragment>
                <h1 className="text-title-body">درایر گاز Purge تبریدی جزو محصولات روتین هوایار نیست ولی قابلیت تولید بصورت خاص را دارد</h1>
                <div className="modelheadbox">
                    <hr className="divider" />
                </div>
                <div className="row hrow mt-4">
                    <Link className="btn btn-dark" to={`/consuling`} >درخواست خرید</Link>
                </div>
            </Fragment>
        );
    }
}
